import { render, staticRenderFns } from "./ProjectSettingsEmbedded.vue?vue&type=template&id=23e29c5d&scoped=true"
import script from "./ProjectSettingsEmbedded.vue?vue&type=script&lang=js"
export * from "./ProjectSettingsEmbedded.vue?vue&type=script&lang=js"
import style0 from "./ProjectSettingsEmbedded.vue?vue&type=style&index=0&id=23e29c5d&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23e29c5d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('23e29c5d')) {
      api.createRecord('23e29c5d', component.options)
    } else {
      api.reload('23e29c5d', component.options)
    }
    module.hot.accept("./ProjectSettingsEmbedded.vue?vue&type=template&id=23e29c5d&scoped=true", function () {
      api.rerender('23e29c5d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/settings/projects/ProjectSettingsEmbedded.vue"
export default component.exports